

/// <reference path="Channel.ts" />

// Generated class BookingChannel_ManagedObject

class BookingChannel_ManagedObject extends Channel
{
}
